module.exports = __webpack_public_path__ + "static/media/style-4.626bd128.svg";